import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PersonIcon from "@mui/icons-material/Person";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import Equalizer from "@mui/icons-material/Equalizer";
import SchoolIcon from "@mui/icons-material/School";
import BiotechIcon from "@mui/icons-material/Biotech";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import HomeIcon from "@mui/icons-material/Home";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import FolderIcon from "@mui/icons-material/Folder";
import DescriptionIcon from "@mui/icons-material/Description";
import ArticleIcon from "@mui/icons-material/Article";
import TableChartIcon from "@mui/icons-material/TableChart";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssessmentIcon from "@mui/icons-material/Assessment";
import EventIcon from "@mui/icons-material/Event";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MailIcon from "@mui/icons-material/Mail";
import SecurityIcon from "@mui/icons-material/Security";
import LockIcon from "@mui/icons-material/Lock";
import GroupIcon from "@mui/icons-material/Group";
import GroupsIcon from "@mui/icons-material/Groups";
import BusinessIcon from "@mui/icons-material/Business";
import StoreIcon from "@mui/icons-material/Store";
import InventoryIcon from "@mui/icons-material/Inventory";
import PaymentIcon from "@mui/icons-material/Payment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import WorkIcon from "@mui/icons-material/Work";
import BadgeIcon from "@mui/icons-material/Badge";
import HistoryIcon from "@mui/icons-material/History";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SearchIcon from "@mui/icons-material/Search";
import MapIcon from "@mui/icons-material/Map";
import PublicIcon from "@mui/icons-material/Public";
import CategoryIcon from "@mui/icons-material/Category";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import HelpIcon from "@mui/icons-material/Help";
import InfoIcon from "@mui/icons-material/Info";
import BookIcon from "@mui/icons-material/Book";
import DevicesIcon from "@mui/icons-material/Devices";
import ExtensionIcon from "@mui/icons-material/Extension";
import BuildIcon from "@mui/icons-material/Build";
import LanguageIcon from "@mui/icons-material/Language";

// Single source of truth for menu icons: both the live Sidebar (resolving a
// menu's stored icon *name* string to a component) and the menu-management
// icon picker read from this same list, so an icon chosen in the picker is
// guaranteed to actually render in the sidebar.
export const MENU_ICONS = [
  { name: "AccountCircleIcon", label: "Akun", Icon: AccountCircleIcon },
  { name: "PersonIcon", label: "Orang", Icon: PersonIcon },
  { name: "EditIcon", label: "Edit", Icon: EditIcon },
  { name: "PersonAddIcon", label: "Tambah Orang", Icon: PersonAddIcon },
  { name: "PeopleAltIcon", label: "Orang-orang", Icon: PeopleAltIcon },
  { name: "LocationCityIcon", label: "Institusi", Icon: LocationCityIcon },
  { name: "Equalizer", label: "Statistik", Icon: Equalizer },
  { name: "SchoolIcon", label: "Sekolah", Icon: SchoolIcon },
  { name: "BiotechIcon", label: "Penelitian", Icon: BiotechIcon },
  { name: "AssignmentIcon", label: "Tugas", Icon: AssignmentIcon },
  { name: "LocalLibraryIcon", label: "Pengajaran", Icon: LocalLibraryIcon },
  { name: "MonetizationOnIcon", label: "Keuangan", Icon: MonetizationOnIcon },
  { name: "ManageAccountsIcon", label: "Pengaturan Akun", Icon: ManageAccountsIcon },
  { name: "HomeIcon", label: "Beranda", Icon: HomeIcon },
  { name: "DashboardIcon", label: "Dashboard", Icon: DashboardIcon },
  { name: "SettingsIcon", label: "Pengaturan", Icon: SettingsIcon },
  { name: "FolderIcon", label: "Folder", Icon: FolderIcon },
  { name: "DescriptionIcon", label: "Deskripsi", Icon: DescriptionIcon },
  { name: "ArticleIcon", label: "Artikel", Icon: ArticleIcon },
  { name: "TableChartIcon", label: "Tabel", Icon: TableChartIcon },
  { name: "BarChartIcon", label: "Grafik Batang", Icon: BarChartIcon },
  { name: "AssessmentIcon", label: "Laporan", Icon: AssessmentIcon },
  { name: "EventIcon", label: "Acara", Icon: EventIcon },
  { name: "CalendarMonthIcon", label: "Kalender", Icon: CalendarMonthIcon },
  { name: "NotificationsIcon", label: "Notifikasi", Icon: NotificationsIcon },
  { name: "MailIcon", label: "Surat", Icon: MailIcon },
  { name: "SecurityIcon", label: "Keamanan", Icon: SecurityIcon },
  { name: "LockIcon", label: "Kunci", Icon: LockIcon },
  { name: "GroupIcon", label: "Grup", Icon: GroupIcon },
  { name: "GroupsIcon", label: "Kelompok", Icon: GroupsIcon },
  { name: "BusinessIcon", label: "Bisnis", Icon: BusinessIcon },
  { name: "StoreIcon", label: "Toko", Icon: StoreIcon },
  { name: "InventoryIcon", label: "Inventaris", Icon: InventoryIcon },
  { name: "PaymentIcon", label: "Pembayaran", Icon: PaymentIcon },
  { name: "ReceiptIcon", label: "Kuitansi", Icon: ReceiptIcon },
  { name: "AccountBalanceIcon", label: "Bank", Icon: AccountBalanceIcon },
  { name: "CreditCardIcon", label: "Kartu Kredit", Icon: CreditCardIcon },
  { name: "WorkIcon", label: "Pekerjaan", Icon: WorkIcon },
  { name: "BadgeIcon", label: "Lencana", Icon: BadgeIcon },
  { name: "HistoryIcon", label: "Riwayat", Icon: HistoryIcon },
  { name: "CloudUploadIcon", label: "Unggah", Icon: CloudUploadIcon },
  { name: "SearchIcon", label: "Cari", Icon: SearchIcon },
  { name: "MapIcon", label: "Peta", Icon: MapIcon },
  { name: "PublicIcon", label: "Publik", Icon: PublicIcon },
  { name: "CategoryIcon", label: "Kategori", Icon: CategoryIcon },
  { name: "LibraryBooksIcon", label: "Perpustakaan", Icon: LibraryBooksIcon },
  { name: "HelpIcon", label: "Bantuan", Icon: HelpIcon },
  { name: "InfoIcon", label: "Info", Icon: InfoIcon },
  { name: "BookIcon", label: "Buku", Icon: BookIcon },
  { name: "DevicesIcon", label: "Perangkat", Icon: DevicesIcon },
  { name: "ExtensionIcon", label: "Ekstensi", Icon: ExtensionIcon },
  { name: "BuildIcon", label: "Alat", Icon: BuildIcon },
  { name: "LanguageIcon", label: "Bahasa", Icon: LanguageIcon },
];

export const resolveMenuIcon = (name) => {
  const entry = MENU_ICONS.find((item) => item.name === name);
  return entry ? React.createElement(entry.Icon) : null;
};
